import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import { mixin as clickaway } from 'vue-clickaway'

import VueApexCharts from 'vue-apexcharts'
import AsyncComputed from 'vue-async-computed'
import './filters'
import './plugins'
import './registerServiceWorker'

Vue.use(AsyncComputed)

Vue.mixin(clickaway)
Vue.component('VueApexChart', VueApexCharts)

Vue.config.productionTip = false

const requireComponent = require.context(
	'./components',
	// look for subfolder
	true,
	/(App|Layout)[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
	// Get component config
	const componentConfig = requireComponent(fileName)
	const componentName = fileName
		.split('/')
		.pop()
		.replace(/\.\w+$/, '')

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	)
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
